import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const HERO_BG = "https://images.unsplash.com/photo-1731283209705-10fa9a57ca66?w=1920&q=80";

const stats = [
  { value: "+500", label: "Edificios Residenciales" },
  { value: "+30", label: "Años de Experiencia" },
  { value: "+100", label: "Marcas Conectadas" },
  { value: "Todo", label: "Chile" },
];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] },
});

const Hero = () => (
  <section
    id="inicio"
    data-testid="hero-section"
    className="relative flex flex-col justify-end"
    style={{ minHeight: "100vh" }}
  >
    {/* Background */}
    <div className="absolute inset-0 z-0 overflow-hidden">
      <img
        src={HERO_BG}
        alt="Santiago de Chile"
        className="w-full h-full object-cover"
        style={{ transform: "scale(1.05)" }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to top, #050505 0%, rgba(5,5,5,0.65) 50%, rgba(5,5,5,0.2) 100%)",
        }}
      />
      <div
        className="absolute inset-0"
        style={{ background: "rgba(5,5,5,0.25)" }}
      />
    </div>

    {/* Vertical label */}
    <div
      className="absolute left-12 bottom-48 z-10 hidden xl:flex items-center gap-3"
      style={{ transform: "rotate(-90deg)", transformOrigin: "left center", marginLeft: "14px" }}
    >
      <div style={{ width: "40px", height: "1px", backgroundColor: "#00E0FF" }} />
      <span
        className="text-zinc-500 font-body"
        style={{ fontSize: "10px", letterSpacing: "0.25em", textTransform: "uppercase", whiteSpace: "nowrap" }}
      >
        Publicidad Residencial — Santiago, Chile
      </span>
    </div>

    {/* Content */}
    <div className="relative z-10 edi-container pb-16 md:pb-24">
      {/* Label */}
      <motion.div {...fadeUp(0)} className="mb-5">
        <span className="section-label">Red Publicitaria Residencial</span>
      </motion.div>

      {/* Main Headline */}
      <motion.h1
        {...fadeUp(0.1)}
        className="section-heading mb-6"
        style={{ fontSize: "clamp(52px, 7vw, 110px)", maxWidth: "900px" }}
      >
        La red publicitaria
        <br />
        <span style={{ color: "#00E0FF" }}>residencial</span>
        <br />
        más grande de Chile.
      </motion.h1>

      {/* Subheadline */}
      <motion.p
        {...fadeUp(0.25)}
        className="font-body text-zinc-300 mb-10"
        style={{ fontSize: "17px", fontWeight: 300, maxWidth: "520px", lineHeight: 1.7 }}
      >
        Conectamos marcas con miles de edificios y comunidades en todo el país.
      </motion.p>

      {/* CTAs */}
      <motion.div {...fadeUp(0.35)} className="flex flex-col sm:flex-row gap-4 mb-20">
        <a
          href="#contacto"
          data-testid="cta-publicitar"
          className="inline-block text-center font-body font-bold uppercase text-xs text-black"
          style={{
            backgroundColor: "#ffffff",
            padding: "16px 36px",
            letterSpacing: "0.18em",
            transition: "background-color 0.3s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#00E0FF")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffffff")}
        >
          Quiero Publicitar
        </a>
        <a
          href="#contacto"
          data-testid="cta-monetizar"
          className="inline-block text-center font-body font-bold uppercase text-xs text-white"
          style={{
            border: "1px solid rgba(255,255,255,0.25)",
            padding: "16px 36px",
            letterSpacing: "0.18em",
            transition: "border-color 0.3s, background-color 0.3s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "rgba(255,255,255,0.8)";
            e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "rgba(255,255,255,0.25)";
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          Quiero Monetizar mi Edificio
        </a>
      </motion.div>

      {/* Stats */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.6 }}
        className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-8"
        style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}
      >
        {stats.map((stat, i) => (
          <div key={i} className="flex flex-col" data-testid={`hero-stat-${i}`}>
            <span
              className="font-heading font-bold text-white"
              style={{ fontSize: "clamp(28px, 3.5vw, 48px)", lineHeight: 1 }}
            >
              {stat.value}
            </span>
            <span
              className="font-body text-zinc-500 mt-2"
              style={{ fontSize: "11px", letterSpacing: "0.18em", textTransform: "uppercase" }}
            >
              {stat.label}
            </span>
          </div>
        ))}
      </motion.div>
    </div>

    {/* Scroll indicator */}
    <motion.div
      animate={{ y: [0, 8, 0] }}
      transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
      className="absolute bottom-8 right-12 z-10 hidden md:flex flex-col items-center gap-2"
    >
      <ArrowDown size={14} color="#52525b" />
    </motion.div>
  </section>
);

export { Hero };
